<template>
  <div class="max-w-screen-sm mx-auto">
    <h1 class="font-heading font-semibold text-4xl mb-3">Automatic Sales Reporting</h1>
    <p class="text-fg-secondary mb-8">Send a sales report each Monday morning.</p>
    <ReportSalesEmailConfig :showDescription="false" />
  </div>
</template>

<script setup lang="ts">
import ReportSalesEmailConfig from '@/modules/report/components/organisms/ReportSalesEmailConfig.vue'
</script>
